import { useEffect, useRef, useState } from 'react';

export default function GooglePlacesInput({ value, onChange, placeholder, className, type = 'city' }) {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const [googleReady, setGoogleReady] = useState(!!window.google);

  useEffect(() => {
    if (window.google) {
      setGoogleReady(true);
      return;
    }
    const interval = setInterval(() => {
      if (window.google) {
        setGoogleReady(true);
        clearInterval(interval);
      }
    }, 100);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!googleReady || !inputRef.current || autocompleteRef.current) return;

    const options = type === 'neighborhood'
      ? {
          types: ['neighborhood', 'sublocality'],
          componentRestrictions: { country: 'es' },
          fields: ['name']
        }
      : {
          types: ['(cities)'],
          componentRestrictions: { country: 'es' },
          fields: ['name']
        };

    autocompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current, options);

    autocompleteRef.current.addListener('place_changed', () => {
      const place = autocompleteRef.current.getPlace();
      const name = (place.name || '').split(',')[0].trim();
      onChange(name);
    });
  }, [googleReady]);

  // Sync input value when value prop changes externally
  useEffect(() => {
    if (inputRef.current && value !== undefined) {
      inputRef.current.value = value;
    }
  }, [value]);

  return (
    <input
      ref={inputRef}
      type="text"
      defaultValue={value}
      placeholder={placeholder}
      className={className}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
